var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "firmware-list" },
    [
      _c(
        "div",
        { staticClass: "header" },
        [
          _c("div", { staticClass: "title" }),
          _c(
            "el-button",
            {
              attrs: {
                disabled: _vm.rolesCode === "SALE",
                type: "add",
                size: "14",
                icon: "el-icon-plus",
              },
              on: {
                click: function ($event) {
                  _vm.dialogVisible = true
                },
              },
            },
            [_vm._v("新建升级任务")]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            "header-cell-style": { background: "#F5F6F7" },
            size: "medium",
          },
        },
        [
          _c("el-table-column", { attrs: { prop: "name", label: "任务名称" } }),
          _c("el-table-column", {
            attrs: { prop: "createTime", label: "创建时间" },
          }),
          _c("el-table-column", {
            attrs: { formatter: _vm.statusFormatter, label: "状态" },
          }),
          _c("el-table-column", {
            attrs: { fixed: "right", label: "操作", width: "270" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "operate" },
                        on: {
                          click: function ($event) {
                            return _vm.handleDetails(scope.row)
                          },
                        },
                      },
                      [_vm._v("详情")]
                    ),
                    scope.row.state == 0
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "text",
                              size: "operate",
                              disabled: _vm.rolesCode === "SALE",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.terminateUpgradeTaskFun(scope.row)
                              },
                            },
                          },
                          [_vm._v("终止")]
                        )
                      : _vm._e(),
                    scope.row.state == 2
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "text",
                              size: "operate",
                              disabled: _vm.rolesCode === "SALE",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.deleteUpgradeTaskFun(scope.row)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          "current-page": _vm.current,
          "page-sizes": [10, 20, 30, 40],
          "page-size": _vm.size,
          layout: "total, sizes, prev, pager, next, jumper",
          total: _vm.total,
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.uploadLoading,
              expression: "uploadLoading",
            },
          ],
          attrs: {
            title: "新建升级任务",
            visible: _vm.dialogVisible,
            width: "830px",
            "before-close": _vm.handleClose,
            "close-on-click-modal": false,
            "custom-class": "upgrade-task-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                rules: _vm.rules,
                model: _vm.form,
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "任务名称", prop: "name" },
                          scopedSlots: _vm._u([
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _c("span", [_vm._v("任务名称")]),
                                  _vm._v(" \n              "),
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        content:
                                          "支持中英文和数字,长度2-32,名称不可重复",
                                        placement: "bottom",
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "iconfont icon-wenhao",
                                      }),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: "32",
                              placeholder: "请输入任务名称",
                            },
                            model: {
                              value: _vm.form.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "name", $$v)
                              },
                              expression: "form.name",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "升级方案", prop: "otaMode" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              on: { change: _vm.handleOtaModeChange },
                              model: {
                                value: _vm.form.otaMode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "otaMode", $$v)
                                },
                                expression: "form.otaMode",
                              },
                            },
                            _vm._l(_vm.otaModeOptions, function (item) {
                              return _c(
                                "el-radio",
                                {
                                  key: item.value,
                                  attrs: { label: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "升级版本号",
                            prop: "upgradeVersion",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              minlength: "1",
                              disabled: true,
                              "show-word-limit": "",
                              placeholder: "当前版本号",
                            },
                            model: {
                              value: _vm.form.upgradeVersion,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "upgradeVersion", $$v)
                              },
                              expression: "form.upgradeVersion",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "可升级版本号（可多选）",
                            prop: "upgradeableVersionList",
                          },
                        },
                        [
                          _c(
                            "el-table",
                            {
                              ref: "versionTable",
                              staticStyle: { width: "60%" },
                              attrs: {
                                data: _vm.upgradeableFirmwareIdOptions,
                                size: "medium",
                                "header-cell-style": { background: "#F5F6F7" },
                              },
                              on: {
                                "selection-change": _vm.handleSelectionChange,
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: { type: "selection", width: "100" },
                              }),
                              _c("el-table-column", {
                                attrs: { prop: "version", label: "版本号" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.form.otaMode === "SOTA"
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "有效截止时间",
                                prop: "taskExpireTime",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "30%" },
                                  model: {
                                    value: _vm.form.taskExpireTime,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "taskExpireTime", $$v)
                                    },
                                    expression: "form.taskExpireTime",
                                  },
                                },
                                _vm._l(
                                  _vm.taskExpireTimeOptions,
                                  function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        { attrs: { label: "升级范围", prop: "upgradeRange" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              on: { change: _vm.handleUpgradeRangeChange },
                              model: {
                                value: _vm.form.upgradeRange,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "upgradeRange", $$v)
                                },
                                expression: "form.upgradeRange",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("全部设备"),
                              ]),
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("特定设备"),
                              ]),
                              _c("el-radio", { attrs: { label: 3 } }, [
                                _vm._v("特定项目"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.form.upgradeRange == 1
                        ? _c(
                            "div",
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "", prop: "deviceIdList" } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "textarea",
                                      rows: 2,
                                      placeholder:
                                        "请输入设备ID,多个设备ID之间以英文“ ; ”分隔",
                                    },
                                    on: { input: _vm.onSpecificDeviceIdInput },
                                    model: {
                                      value: _vm.form.deviceIdList,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "deviceIdList", $$v)
                                      },
                                      expression: "form.deviceIdList",
                                    },
                                  }),
                                  _c("specificDeviceDialog", {
                                    ref: "specificDevice",
                                    attrs: {
                                      "device-id-list": _vm.form.deviceIdList,
                                      "product-id": _vm.productId,
                                    },
                                    on: {
                                      "update-deviceIdList":
                                        _vm.updateDeviceIdList,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "button-container__right" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        size: "mini",
                                        type: "primary",
                                        disabled: !_vm.form.deviceIdList,
                                      },
                                      on: {
                                        click:
                                          _vm.handleOpenResultForSpecificDevice,
                                      },
                                    },
                                    [_vm._v("确定")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.form.upgradeRange == 3
                        ? _c(
                            "div",
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "project-device-form-item",
                                  attrs: { label: "", prop: "deviceIdList" },
                                },
                                [
                                  _c("specificProjectDeviceList", {
                                    ref: "specificProject",
                                    staticClass: "specific-project-device-list",
                                    attrs: { "product-id": _vm.productId },
                                    on: {
                                      "update-deviceIdList":
                                        _vm.updateDeviceIdList,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("conflictDetailsDialog", {
            ref: "conflictDetails",
            on: { confirm: _vm.onConfirm },
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "14" },
                  on: {
                    click: function ($event) {
                      return _vm.handleClose()
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "14",
                    disabled: !_vm.canSaveUpgradeTask,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm("form")
                    },
                  },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            title: "升级任务详情",
            visible: _vm.drawer,
            direction: _vm.direction,
            size: "720px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
          scopedSlots: _vm._u([
            {
              key: "title",
              fn: function () {
                return [
                  _c("div", { staticClass: "custom-header" }, [
                    _c("span", [_vm._v("升级任务详情")]),
                    _c("span", { staticClass: "left width-60" }, [
                      _vm._v("版本号："),
                    ]),
                    _c("span", { staticClass: "right" }, [
                      _vm._v(_vm._s(_vm.taskInfo.upgradeVersion)),
                    ]),
                    _c("div", { staticClass: "status" }, [
                      _c("div", { staticClass: "status-icon" }),
                      _c("div", [_vm._v(_vm._s(_vm.taskInfo.state))]),
                    ]),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.taskLoading,
                  expression: "taskLoading",
                },
              ],
            },
            [
              _c("div", { staticClass: "taskInfo" }, [
                _c(
                  "div",
                  { staticClass: "InfoTitle" },
                  [
                    _vm._v("任务基本信息\n          "),
                    _c(
                      "el-button",
                      {
                        staticClass: "refresh",
                        attrs: {
                          type: "add",
                          size: "mini",
                          icon: "el-icon-refresh-right",
                        },
                        on: { click: _vm.handleDetails },
                      },
                      [_vm._v("刷新")]
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "martop-16" }, [
                  _c("span", { staticClass: "left" }, [_vm._v("任务名称")]),
                  _c("span", { staticClass: "right" }, [
                    _vm._v(_vm._s(_vm.taskInfo.name)),
                  ]),
                ]),
                _c("div", { staticClass: "martop-16" }, [
                  _c("span", { staticClass: "left" }, [_vm._v("升级方案")]),
                  _c("span", { staticClass: "right" }, [
                    _vm._v(_vm._s(_vm.getOtaName(_vm.taskInfo.otaMode))),
                  ]),
                ]),
                _c("div", { staticClass: "martop-16" }, [
                  _c("span", { staticClass: "left" }, [_vm._v("升级版本号")]),
                  _c("span", { staticClass: "right" }, [
                    _vm._v(_vm._s(_vm.form.upgradeVersion)),
                  ]),
                ]),
                _c("div", { staticClass: "martop-16" }, [
                  _c("span", { staticClass: "left" }, [_vm._v("可升级版本号")]),
                  _c("span", { staticClass: "right" }, [
                    _vm._v(_vm._s(_vm.taskInfo.upgradeableVersionList)),
                  ]),
                ]),
                _vm.taskInfo.otaMode === "SOTA"
                  ? _c("div", { staticClass: "martop-16" }, [
                      _c("span", { staticClass: "left" }, [
                        _vm._v("有效截止时间"),
                      ]),
                      _c("span", { staticClass: "right" }, [
                        _vm._v(_vm._s(_vm.taskInfo.taskExpireTime || "-")),
                      ]),
                    ])
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "taskInfo" }, [
                _c("div", { staticClass: "InfoTitle" }, [
                  _vm._v("任务执行结果"),
                ]),
                _c("div", { staticClass: "martop-16" }, [
                  _c("span", { staticClass: "left" }, [_vm._v("可升级设备数")]),
                  _c("span", { staticClass: "right" }, [
                    _vm._v(_vm._s(_vm.taskInfo.deviceTotalNumber)),
                  ]),
                ]),
                _c("div", { staticClass: "martop-16" }, [
                  _c("span", { staticClass: "left" }, [
                    _vm._v("升级成功设备数"),
                  ]),
                  _c("span", { staticClass: "right" }, [
                    _vm._v(_vm._s(_vm.taskInfo.deviceSuccessNumber)),
                  ]),
                ]),
                _c("div", { staticClass: "martop-16" }, [
                  _c("span", { staticClass: "left" }, [
                    _vm._v("升级失败设备数"),
                  ]),
                  _c("span", { staticClass: "right" }, [
                    _vm._v(_vm._s(_vm.taskInfo.deviceFailureNumber)),
                  ]),
                ]),
                _c("div", { staticClass: "martop-16" }, [
                  _c("span", { staticClass: "left" }, [_vm._v("未升级设备数")]),
                  _c("span", { staticClass: "right" }, [
                    _vm._v(_vm._s(_vm.taskInfo.deviceNotStartNumber)),
                  ]),
                ]),
                _c("div", { staticClass: "martop-16" }, [
                  _c("span", { staticClass: "left" }, [
                    _vm._v("离线排队设备数"),
                  ]),
                  _c("span", { staticClass: "right" }, [
                    _vm._v(_vm._s(_vm.taskInfo.offLineNumber)),
                  ]),
                ]),
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.dynamicLink,
                      rel: "opener",
                      target: "_blank",
                    },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "refresh",
                        attrs: { type: "add", size: "mini" },
                      },
                      [_vm._v("查看ota任务具体数据")]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }